@if (!data?.autoOpen) {
  <div class="close-icon">
    <img src="../../../assets/icon/close-icon.svg" alt="Close icon" (click)="close()" />
  </div>
}
<ion-row class="all-content">
  <div>
    <ion-col class="content-wrapper" size="12">
      <img src="../../../assets/icon/verify_lock.png" alt="" class="lock" />
    </ion-col>
    <ion-col class="content-wrapper" size="12">
      <p class="verify-phone-number">{{ (isEmailValid() ? "verify-phone-number.verify_email_text" : "verify-phone-number.Verify") | translate }}</p>
    </ion-col>
    <ion-col class="content-wrapper" size="12">
      <form [formGroup]="verifyPhoneCodeForm" (ngSubmit)="resendOtp()" class="otp-form" #otpForm>
        <input
          #otpAutofillInput
          type="tel"
          name="one-time-code"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="4"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          class="otp-autofill-capture"
          tabindex="-1"
          aria-hidden="true"
          (input)="onOtpAutofillCapture($event)"
          (change)="onOtpAutofillCapture($event)"
          />
        <input
          type="tel"
          class="big-input"
          name="otp-1"
          aria-label="OTP digit 1"
          pattern="[0-9]*"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="4"
          formControlName="code1"
          (input)="handleOtpInput($event, 0)"
          (paste)="onOtpPaste($event, 0)"
          (keydown)="onOtpKeydown($event, 0)"
          (focus)="onOtpFocus($event)"
          [ngClass]="hideOtpInput == true ? 'incorrectOtp' : 'correctOtp'"
          />
          <input
            type="tel"
            class="big-input"
            name="otp-2"
            aria-label="OTP digit 2"
            pattern="[0-9]"
            inputmode="numeric"
            autocomplete="off"
            maxlength="1"
            formControlName="code2"
            (input)="handleOtpInput($event, 1)"
            (paste)="onOtpPaste($event, 1)"
            (keydown)="onOtpKeydown($event, 1)"
            (focus)="onOtpFocus($event)"
            [ngClass]="hideOtpInput == true ? 'incorrectOtp' : 'correctOtp'"
            />
            <input
              type="tel"
              class="big-input"
              name="otp-3"
              aria-label="OTP digit 3"
              pattern="[0-9]"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              formControlName="code3"
              (input)="handleOtpInput($event, 2)"
              (paste)="onOtpPaste($event, 2)"
              (keydown)="onOtpKeydown($event, 2)"
              (focus)="onOtpFocus($event)"
              [ngClass]="hideOtpInput == true ? 'incorrectOtp' : 'correctOtp'"
              />
              <input
                type="tel"
                class="big-input"
                name="otp-4"
                aria-label="OTP digit 4"
                pattern="[0-9]"
                inputmode="numeric"
                autocomplete="off"
                maxlength="1"
                formControlName="code4"
                (input)="handleOtpInput($event, 3)"
                (paste)="onOtpPaste($event, 3)"
                (keydown)="onOtpKeydown($event, 3)"
                (focus)="onOtpFocus($event)"
                [ngClass]="hideOtpInput == true ? 'incorrectOtp' : 'correctOtp'"
                />
              </form>
            </ion-col>
            @if (spinnerAnimation) {
              <div class="spinners">
                <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="60"> </mat-progress-spinner>
                <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="60">
                </mat-progress-spinner>
              </div>
            }
            @if (hideOtpInput == true && !spinnerAnimation) {
              <p class="code-Errormsg">
                <ion-icon name="warning"></ion-icon> {{ "verify-phone-number.error_msg" | translate }}
              </p>
            }
            <ion-col class="content-wrapper" size="12">
              <p class="code-sent">
                {{ "verify-phone-number.code" | translate }} <span class="code-sent-mobile-no">{{ data?.msn }}</span>
              </p>
            </ion-col>
            <ion-col class="content-wrapper" size="12">
              <div style="display: flex; flex-direction: column">
                <div class="time-left">
                  {{ "verify-phone-number.time-left" | translate }} <span class="time-left-timer" #timer></span>
                </div>
                <p class="resend-code" [class.resend-code--disabled]="!resendAllowed" (click)="resendOtp()">
                  {{ "verify-phone-number.Resend" | translate }}
                </p>
              </div>
            </ion-col>
          </div>
          @if (!data?.autoOpen) {
            <ion-col class="content-wrapper" size="12" (click)="backToLogin()">
              <p class="back-to-login">
                <span class="login-back-icon" (click)="backToLogin()">← </span>
                {{ (fromHome ? "verify-failed-sms.back" : "verify-phone-number.Back") | translate }}
              </p>
            </ion-col>
          }
        </ion-row>
